var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"`eissublist`"}},[_c('app-gridview',{attrs:{"parentData":{
            tabHeaders: this.dataHeader,
            tabItems: this.dataItems,
            pageTitle: this.pageTitle,
            search: this.search,
        },"pdfOptions":{ format: 'a3', fontSize: 7, cellPadding: 2, overflow: 'linebreak', margin: { left: 5, right: 5 }, startY: 17, titleSize: 11, titleX: 5, titleY: 12 }},on:{"EditItem":function($event){return _vm.editItemHandler($event)},"DeleteItem":function($event){return _vm.deleteItemHandler($event)},"NewPressed":_vm.newRecordHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }